const convertNumber = (value, toFixed) => {
    if (value === '' || isNaN(Number(value)))
        return value;
    let result;
    if (toFixed) {
        const reg = new RegExp(`^\\d+(?:\\.\\d{0,${toFixed}})?`);
        const newVal = reg.exec(String(value));
        result = Number(newVal ? newVal : value);
    }
    else {
        result = parseInt(String(value), 10);
    }
    return result;
};

export { convertNumber };
//# sourceMappingURL=convert-number.js.map
